import { PrestamoAbonoService } from './../../services/prestamo-abono/prestamo-abono.service';
import { AfiliacionService } from './../../services/afiliacion/afiliacion.service';
import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';

import { PrestamosService } from 'src/app/services/prestamos/prestamos.service';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import Swal from 'sweetalert2';



export interface DialogData
{
    id: any,
    idAfiliado: any,    
    tiposRechazo: [],
    tipoRechazo: any,
    email: any,
    nombreCompleto: any,
    nombreProducto: any,
    comentarioRechazo: any
}

@Component({
    selector: 'rechazar-cuota-pago-afiliado',
    templateUrl: '../../pages/afiliacion/pago-cuota/rechazar-cuota-pago.html',
    styleUrls: ['../../pages/afiliacion/pago-cuota/rechazar-cuota-pago.css']
  })
export class DialogTipoRechazoCuotaPagoAfiliado
{
 tiposRechazo: any

  constructor( public dialogRef: MatDialogRef<DialogTipoRechazoCuotaPagoAfiliado>,
    private prestamosService: PrestamosService,
    private prestamoAbonoService:PrestamoAbonoService,
    private afiliacionService:AfiliacionService,    
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog, )
    { 
      
    
    }
    
    ngOnInit(): void
    { this.loadData() }
    loadData()
    {
      this.prestamoAbonoService.motivoRechazo(4).then
      (
          
          rechazos => {this.tiposRechazo = rechazos
             
            }
      )
      .catch ( error => {console.log(error)
    } )
    
    }
  onRechazarClick()
  {
    
    
    let vm = this
    
    let idMotivoRechazo = this.data.tipoRechazo.split('-')[0]
    let motivoRechazo = this.data.tipoRechazo.split('-')[1]
    
    const dialogRef = this.dialog.open(ConfirmationDialog,
      {
          data: { message: '¿Esta seguro de rechazar la Solicitud de Pago?', buttonText: { ok: 'Si', cancel: 'No' } }
      })
    dialogRef.afterClosed().subscribe((confirmed: boolean) =>
    {
      if (confirmed)
      {
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
    
        this.afiliacionService.rechazarPagoCuota(this.data.idAfiliado,this.data.id,
        idMotivoRechazo,
        motivoRechazo, this.data.comentarioRechazo).then(
          ()=>
          {
       
            this.openAlertDialog('La solicitud de pago fue rechazada exitosamente.', 'btn-success')
            
            Swal.close();
            return false;
          }
          ) .catch ( error =>
          {
              console.log(error)
              Swal.close();
              this.openAlertDialog('Ha ocurrido un error al rechazar el pago.', 'btn-danger')
              return false;
          } )
      }
      this.dialogRef.close();
    })

    }
    
    onCancelarClick(): void { this.dialogRef.close() }
    
    openAlertDialog(mensaje: string, clase: string)
    {
    this.dialog.open(AlertDialogComponent, {
    data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
      })
      }
    }
    